module.exports = __webpack_public_path__ + "static/media/18.55de0624.jpg";